// This module manages the state of whether a session is being recorded
let isRecordingSession = false
let sessionRecordingStartTime: number | null = null

// Returns whether the current session is being recorded
export function isSessionBeingRecorded(): boolean {
  return isRecordingSession
}

// Returns whether session recording has been active for a minimum time
// This helps ensure Datadog has actually started recording before we generate URLs
export function isSessionRecordingActive(): boolean {
  if (!isRecordingSession || !sessionRecordingStartTime) {
    return false
  }

  // Wait at least 500ms after starting recording before allowing URL generation
  const minRecordingTime = 500 // 500ms
  return Date.now() - sessionRecordingStartTime >= minRecordingTime
}

// Updates the recording state of the current session
export function setSessionRecordingState(recording: boolean): void {
  isRecordingSession = recording
  if (recording) {
    sessionRecordingStartTime = Date.now()
  } else {
    sessionRecordingStartTime = null
  }
}
